import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class MenuService {
  isOpen: Boolean = false;
  @Output() change: EventEmitter<Boolean> = new EventEmitter();

  toggle(open: boolean) {
    this.isOpen = open;
    this.change.emit(this.isOpen);
  }
}
